import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:rounded-md focus:bg-ink focus:px-4 focus:py-2 focus:text-ink-foreground'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main-content' tabIndex={-1} className='flex-1 focus:outline-none'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
